import apiClient from "../apiClient";

export const ShiftSchedulesAPI = {
  getAll: () => apiClient.get("/api/v1/shift-schedules"),
  getAllPaginated: (params) => {
    const searchParams = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== "") {
        searchParams.append(key, String(value));
      }
    });
    return apiClient.get(
      `/api/v1/shift-schedules/list?${searchParams.toString()}`
    );
  },
  createShift: (payload) => {
    return apiClient.post(`/api/v1/shift-schedules`, payload);
  },
  getById: (id) => apiClient.get(`/api/v1/shift-schedules/list/${id}`),
  updateShift: ({ id, payload }) => {
    return apiClient.put(`/api/v1/shift-schedules/${id}`, payload);
  },
  deleteById: (id) => apiClient.delete(`/api/v1/shift-schedules/${id}`),
};
